import { MuiStylesType } from 'model/muiStyles.model';
import zeplinColor from 'theme/Color';

const muiStyles: MuiStylesType = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '24px',
    bgcolor: 'black',
    gap: '16px',
  },

  companyIdentity: { display: 'flex', justifyContent: 'space-between', gap: '16px' },

  companyMetaContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    color: zeplinColor.Neutral1,
  },

  companyMeta: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
  },

  tooltip: { backgroundColor: zeplinColor.Neutral10, borderRadius: '8px', marginTop: '0' },

  title: {
    maxWidth: '250px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    textWrap: 'nowrap',
    overflow: 'hidden',
  },

  targetButton: {
    bgcolor: zeplinColor.BasicBlack,
    border: `1px solid ${zeplinColor.Neutral1}`,
    padding: '3px 12px',
    borderRadius: '50px',
    textTransform: 'capitalize',
    color: zeplinColor.Neutral1,
    ':hover': {
      bgcolor: zeplinColor.Neutral10,
    },
    textWrap: 'nowrap',
  },

  websiteContainer: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
  },

  stats: {
    display: 'flex',
    width: '100%',
    gap: '12px',
  },

  statContainer: {
    bgcolor: zeplinColor.Neutral11,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '8px 12px',
    borderRadius: '10px',
    justifyContent: 'space-between',
  },

  followButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '29px',
    height: '29px',
    border: `1px solid ${zeplinColor.Neutral1}`,
  },

  followIcon: {
    color: zeplinColor.BasicBlack,
  },
};

export default muiStyles;
